package org.example.zone360.pages.coachDetails.sessionAllDetails.speakingBox

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.window
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.formatSessionMinutes
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.SessionDataDetailsResponse
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun SpeakingSub(
    sessionData: GetSessionsData,
    sitePalette: SitePalette
){
    Column(
        modifier = Modifier.fillMaxWidth()
            .then(
                if (window.screen.width > 470) Modifier.height(125.px) else Modifier
            )
            .margin(top = 15.px)
            .borderRadius(12.px)
            .border(
                1.px,
                style = LineStyle.Solid,
                color = sitePalette.coachDetailsBoxBorder.rgb
            )
            .padding(topBottom = 8.px, leftRight = 16.px)
    ) {
        SectionTitle("Speaking", bottom = if (window.screen.width > 470) 5.px else 10.px)
        Row(
            modifier = Modifier.fillMaxWidth()
                .margin(top = if (window.screen.width < 470) 0.px else 10.px)
                .rowGap(if (window.screen.width > 470) 0.px else 15.px)
                .flexWrap(FlexWrap.Wrap),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Column(modifier = Modifier.gap(10.px)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Image(
                        src = Res.Images.total_words,
                        modifier = Modifier.size(17.px).margin(right = 4.px)
                    )
                    FieldTitleTextNormalSimple(
                        text = "Total Words: ",
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                    FieldTitleTextNormalSimple(
                        text = sessionData.wordCount.toString(),
                        fontWeight = 500,
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                }
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Image(
                        src = Res.Images.total_keywords,
                        modifier = Modifier.size(17.px).margin(right = 4.px)
                    )
                    FieldTitleTextNormalSimple(
                        text = "Total Keywords: ",
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                    FieldTitleTextNormalSimple(
                        text = sessionData.totalKeywords.toString(),
                        fontWeight = 500,
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                }
            }
            Column(modifier = Modifier.gap(10.px).margin(bottom = 5.px)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Image(
                        src = Res.Images.total_duration,
                        modifier = Modifier.size(16.px).margin(right = 4.px)
                    )
                    FieldTitleTextNormalSimple(
                        text = "Total Duration: ",
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                    FieldTitleTextNormalSimple(
                        text = sessionData.recordTime.toLongOrNull()?.let {
                            "${(it / 1000).formatSessionMinutes()} mins"
                        } ?: "Invalid Time",
                        fontWeight = 500,
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                }
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Image(
                        src = Res.Images.recording_Voice,
                        modifier = Modifier.size(17.px).margin(right = 4.px)
                    )
                    FieldTitleTextNormalSimple(
                        text = "Speaking: ",
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                    FieldTitleTextNormalSimple(
                        text = "${sessionData.speakingTime.formatSessionMinutes()} mins",
                        fontWeight = 500,
                        fontFamily = Constants.IBM_FONT,
                        fontSize = 14.px
                    )
                }
            }
        }
    }
}


